'use client';

import React from 'react';
import { formatPercentage } from '@benzinga/utils';
import { getColorByValue } from '@benzinga/frontend-utils';
import styled from '@benzinga/themetron';

export interface TickerPercentageProps {
  value: number;
}

export const TickerPercentage: React.FC<TickerPercentageProps> = ({ value }) => {
  return (
    <TickerPercentageWrapper className="ticker-percentage" value={value}>
      {value > 0 ? `+${formatPercentage(value)}%` : `${formatPercentage(value)}%`}
    </TickerPercentageWrapper>
  );
};

export const TickerPercentageWrapper = styled.span<TickerPercentageProps>`
  color: ${({ theme, value }) => getColorByValue(theme, value)} !important;
  font-size: 0.75rem;
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  padding-left: 4px;
`;
